module.exports = __webpack_public_path__ + "static/media/data4.3595ae99.jpg";